// import Link from 'next/link';
import { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { Link, useNavigate } from 'react-router-dom';
// import { auth } from '@/firebase';
// import { useRouter } from 'next/router';

export default function Signup() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [secretKey, setSecretKey] = useState('');

  //   const user = auth.currentUser;
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [secretKeyError, setSecretKeyError] = useState('');
  const [registerError, setRegisterError] = useState(null);

  const registerUser = async (e) => {
    e.preventDefault();
    // Reset previous error messages
    setEmailError('');
    setPasswordError('');
    setConfirmPasswordError('');
    setSecretKeyError('');
    setRegisterError(null);
    // Email validation
    const emailRegex = /^\S+@\S+\.\S+$/;
    if (!emailRegex.test(email)) {
      setEmailError('Please enter a valid email address');
      return;
    }
    setEmailError('');

    // Password validation
    if (password.length < 6) {
      setPasswordError('Password should be at least 6 characters long');
      return;
    }
    setPasswordError('');

    // Confirm password validation
    if (password !== confirmPassword) {
      setConfirmPasswordError('Passwords do not match');
      return;
    }
    setConfirmPasswordError('');

    // Secret key validation
    const secretKeyFromCompanyHead = 'asdf@951';
    if (secretKey !== secretKeyFromCompanyHead) {
      setSecretKeyError('Invalid secret key');
      return;
    }
    setSecretKeyError('');

    // If all validations pass, perform the user registration logic here
    try {
      // const userCredential = await createUserWithEmailAndPassword(
      await createUserWithEmailAndPassword(auth, email, password);
      // const user = userCredential.user;
      alert('Signup successfully');
      navigate('/');
    } catch (err) {
      const errorCode = err.code;
      setRegisterError(errorCode.replace('auth/', ' '));
      const errorMessage = err.message;
      console.log('Error registering user', errorCode, errorMessage);
    }
  };

  return (
    <div className="flex items-center h-full mt-24 animate__animated animate__fadeIn mb-3">
      <form className="relative flex flex-col items-center justify-center grow">
        <div className="w-full md:p-6 px-2 bg-white rounded-md md:shadow-md md:max-w-xl md:border-t">
          <h1 className="text-3xl font-bold text-center text-gray-700">
            AL Business House
          </h1>
          <div className="mt-6">
            <div className="mb-4">
              <label
                htmlFor="email"
                className="block text-sm font-semibold text-gray-800"
              >
                Email
              </label>
              <input
                type="email"
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {emailError && (
                <p className="text-xs text-rose-500 mt-1">{emailError}</p>
              )}
            </div>
            <div className="mb-4">
              <label
                htmlFor="password"
                className="block text-sm font-semibold text-gray-800"
              >
                Password
              </label>
              <input
                type="password"
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {passwordError && (
                <p className="text-xs text-rose-500 mt-1">{passwordError}</p>
              )}
            </div>

            <div className="mb-4">
              <label
                htmlFor="password"
                className="block text-sm font-semibold text-gray-800"
              >
                Confirm Password
              </label>
              <input
                type="password"
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              {confirmPasswordError && (
                <p className="text-xs text-rose-500 mt-1">
                  {confirmPasswordError}
                </p>
              )}
            </div>

            <div className="mb-4">
              <label
                htmlFor="password"
                className="block text-sm font-semibold text-gray-800"
              >
                Secret Key
              </label>
              <input
                type="password"
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                value={secretKey}
                onChange={(e) => setSecretKey(e.target.value)}
              />
              {secretKeyError && (
                <p className="text-xs text-rose-500 mt-1">{secretKeyError}</p>
              )}
            </div>
            {registerError && (
              <p className="text-xs text-rose-500 mt-1">{registerError}</p>
            )}

            <div className="mt-2">
              <button
                className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-gray-700 rounded-md hover:bg-gray-600 focus:outline-none focus:bg-gray-600"
                onClick={(e) => registerUser(e)}
              >
                Signup
              </button>
            </div>
          </div>

          <p className="mt-4 text-sm text-center text-gray-700">
            Don't have an account?{' '}
            <Link
              to="/login"
              className="font-medium text-blue-600 hover:underline"
            >
              Login
            </Link>
          </p>
        </div>
      </form>
    </div>
  );
}
